import { StrictMode } from 'react';
import { Databuddy } from '@databuddy/sdk/react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { ToastProvider } from '@/components/Toast';
import App from './App';
import { initMonitoring } from './monitoring';

export function Root({ enableInsights = import.meta.env.PROD }: { enableInsights?: boolean }): React.JSX.Element {
  // Databuddy client ID for privacy-first analytics (read at render time for testability)
  const databuddyClientId = import.meta.env.VITE_DATABUDDY_CLIENT_ID;
  // Check for valid client ID (must be truthy and not the literal string "undefined")
  const hasValidClientId = databuddyClientId && databuddyClientId !== 'undefined';

  return (
    <StrictMode>
      <ToastProvider>
        <App />
        {enableInsights && hasValidClientId && (
          <Databuddy
            clientId={databuddyClientId}
            trackHashChanges
            trackAttributes
            trackOutgoingLinks
            trackInteractions
            trackWebVitals
            trackErrors
            enableBatching
          />
        )}
      </ToastProvider>
    </StrictMode>
  );
}

initMonitoring();

const rootElement = document.getElementById('root');

if (rootElement) {
  if (import.meta.env.MODE !== 'test') {
    createRoot(rootElement).render(<Root />);
  }
} else if (import.meta.env.DEV && import.meta.env.MODE !== 'test') {
  console.error('Failed to find root element for React app');
}
